import $ from 'jquery'; 

$(document).ready(function(){
    if($('.comments').length){
        getPostComments()
    }
}); 

function getPostComments(){
    var id = $('.commments-list').attr('data-id'); 
    console.log(id);
}